import { ButtonType, HeadlineTitle } from 'modules/ui';
import { Breadcrumbs } from 'modules/ui/breadcrumbs';
import { useHistory } from 'react-router-dom';
import {
  ContentContainer,
  StyledBackButton,
  StyledPageWithHeader,
  StyledBody,
  StyledSubtitle,
} from './styled';

export interface PageWithHeaderProps {
  breadcrumbs?: { text: string; url?: string }[];
  title?: string;
  subtitle?: string;
  description?: string;
  backButton?: {
    text: string;
    toPath: string;
  };
}

export const PageWithHeader: React.FC<PageWithHeaderProps> = ({
  breadcrumbs,
  title,
  subtitle,
  description,
  children,
  backButton,
  ...props
}) => {
  const history = useHistory();

  return (
    <StyledPageWithHeader>
      {backButton && (
        <StyledBackButton
          type={ButtonType.SecondaryAction}
          text={backButton.text}
          onClick={() => history.push(backButton.toPath)}
        />
      )}
      {breadcrumbs && <Breadcrumbs steps={breadcrumbs} />}
      {title && <HeadlineTitle>{title}</HeadlineTitle>}
      {subtitle && <StyledSubtitle>{subtitle}</StyledSubtitle>}
      {description && <StyledBody>{description}</StyledBody>}
      <ContentContainer>{children}</ContentContainer>
    </StyledPageWithHeader>
  );
};
